import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c(VSkeletonLoader,{staticClass:"mb-4",attrs:{"height":"40","type":"image"}}),_c(VSkeletonLoader,{attrs:{"height":"40","type":"button"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }